/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_TitleInputs */

const cs_auth_forgot_title = /** @type {(inputs: Auth_Forgot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapomenuté heslo`)
};

const en_auth_forgot_title = /** @type {(inputs: Auth_Forgot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password`)
};

/**
* | output |
* | --- |
* | "Forgot password" |
*
* @param {Auth_Forgot_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_title = /** @type {((inputs?: Auth_Forgot_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_title(inputs)
	return cs_auth_forgot_title(inputs)
});